import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";

const Seo = ({ title, description, ogImage }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `);

  const defaultTitle = data.site.siteMetadata.title;
  const defaultDescription = data.site.siteMetadata.description;
  const defaultOgImage = "/og.png"; // Fallback image if no ogImage is provided

  // Check if ogImage is defined and if it starts with 'http', otherwise fall back to the defaultOgImage
  const absoluteOgImage = ogImage && ogImage.startsWith("http")
    ? ogImage
    : `https://rootstock.io${ogImage || defaultOgImage}`;

  return (
    <>
      {/* Page Title */}
      <title>{title || defaultTitle}</title>

      {/* Meta Description */}
      <meta name="description" content={description || defaultDescription} />

      {/* Open Graph Tags (for Facebook, LinkedIn, etc.) */}
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={absoluteOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={absoluteOgImage} />
      <meta name="twitter:image:alt" content={title || defaultTitle} />

      {/* Optionally add the site's Twitter handle */}
      <meta name="twitter:site" content="@rootstock_io" />
    </>
  );
};

export default Seo;
